module.exports = __webpack_public_path__ + "img/illustration-out-of-range.3f94b197.svg";